import { render } from "./POSPage.vue?vue&type=template&id=505f74ee"
import script from "./POSPage.vue?vue&type=script&lang=js"
export * from "./POSPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__